import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapKodeOrder: {
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    borderRadius: "10px",
  },
  wrapNotif: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "#EFF1FF",
  },
  wrapNotifFree: {
    display: "flex",
    // justifyContent: "center",
    alignItems: "center",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "12px",
    paddingBottom: "12px",
    backgroundColor: "#EFF1FF",
  },
  pilihSemuaSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // position: "fixed",
    maxWidth: "100%",
    zIndex: 999,
    width: 960,
  },
  wrapPilihSemua: {
    paddingLeft: "2px",
    display: "flex",
    alignItems: "center",
    borderRadius: "10px",
  },
  tambahProduk: { paddingRight: "15px" },
  wrapAlamat: {
    display: "flex",
    justifyContent: "space-between",
  },
  wrapBtnList: {
    display: "flex",
    justifyContent: "center",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    [theme.breakpoints.up("lg")]: {
      bottom: theme.spacing(2),
      right: theme.spacing(30),
    },
  },
  // fab1: {
  //   position: "fixed",
  //   bottom: theme.spacing(10),
  //   right: theme.spacing(4),
  // },
  emptyCart: {
    display: "flex",
    textAlign: "center",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 60px)",
    paddingLeft: 30,
    paddingRight: 30,
  },
  emptyCartTitle: {
    fontWeight: 600,
  },
  btnCounter: {
    height: 24,
    margin: 10,
    justifyContent: "center",
    display: "flex",
  },
  // liquidRed: {
  //   fontSize: "13px",
  //   color: "red",
  // },
  medium: {
    width: 50,
    height: 50,
    borderRadius: 10,
  },
  decrement: {
    // borderTopRightRadius: 0,
    // borderBottomRightRadius: 0,
    // borderTopLeftRadius: 5,
    // borderBottomLeftRadius: 5,
    // border: "1px solid #E5E5E5",
    // backgroundColor: "#bdc3c7",
    marginRight: "10px",
    "&:hover": {
      backgroundColor: "#bdc3c7",
    },
    color: "#2c3e50",
  },
  increment: {
    // borderTopRightRadius: 5,
    // borderBottomRightRadius: 5,
    // borderTopLeftRadius: 0,
    // borderBottomLeftRadius: 0,
    // backgroundColor: "#bdc3c7",
    // border: "1px solid #E5E5E5",
    marginLeft: "10px",
    "&:hover": {
      backgroundColor: "#bdc3c7",
    },
    color: "#2c3e50",
  },
  displayCounter: {
    backgroundColor: "#FFFF",
    // borderTop: "1px solid #E5E5E5",
    borderBottom: "1px solid #E5E5E5",
    color: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 30,
    userSelect: "none",
  },

  btnNote: {
    display: "flex",
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #FFE3AB",
    backgroundColor: "#FFFCF5",
    fontSize: 12,
    width: "100%",
    outline: "none",
    color: "rgba(0,0,0,0.6)",
    alignItems: "center",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#FFFCF5",
    },
  },

  txtNote: {
    flex: 1,
    marginLeft: 12,
    textAlign: "left",
    whiteSpace: "pre-line",
    wordBreak: "break-all",
  },
  desc: {
    fontSize: 12,
    padding: "10px 0px",
    margin: 0,
    textAlign: "left",
  },
  headProduk: {
    // fontSize: 13,
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    marginBottom:5
  },
  root2: {
    margin: 0,
    // marginLeft: -8,
    // borderRadius: 0,
    maxWidth: "960px",
    // alignItems:"center",
    marginInline: "auto",
    // borderRadius: 8,
    padding: "20px",
    borderWidth: 2,
    // marginLeft:"45px",
    // marginRight:"65px"
    // marginTop: 50
  },
  totalHarga: {
    // fontSize: 13,
    display: "flex",
    justifyContent: "space-between",
    margin: "10px",
  },
  liquidPrimary: {
    fontSize: 13,
    textTransform: "capitalize",
  },
  liquidPre: {
    fontSize: 10,
    textTransform: "capitalize",
  },
  liquidDelete: {
    fontSize: 13,
    color: "red",
  },
  liquidSmall: {
    fontSize: 12.3,
    textTransform: "capitalize",
  },
  liquidSmallGrey: {
    fontSize: 12.3,
    color: "grey",
    textTransform: "capitalize",
  },
  liquidSmallBold: {
    fontSize: 12.3,
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  liquidPrimaryBold: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: "5px",
  },
  liquidNotif: {
    fontSize: 12,
    "@media (max-width: 480px)": {
      fontSize: 11,
    },
    "@media (max-width: 360px)": {
      fontSize: 9,
    },
  },
  liquidBold: {
    fontSize: 14,
    fontWeight: "bold",
  },
  liquidSecondList: {
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidRed: {
    fontSize: 12,
    color: "red",
  },
  invalidStok: {
    border: "1px solid rgba(255, 0, 0, 0.8)",
    borderRadius: "10px",
  },
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100%",
  },
  root: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
    // marginTop: 40,
  },
  checkoutSection: {
    position: "fixed",
    maxWidth: "100%",
    zIndex: 999,
    width: 960,
    bottom: 0,
  },
  btnInfaq: {
    marginBottom: 16,
    display: "flex",
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #008080",
    backgroundColor: "#ECFDF0",
    fontSize: 12,
    width: "100%",
    outline: "none",
    color: "rgba(0,0,0,0.6)",
    alignItems: "center",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#ECFDF0",
    },
  },
  showMore: {
    color: "rgb(192,192,192)",
    cursor: "pointer",
  },
  wrapVoucher: {
    padding: "10px",
  },
  boxPre: {
    padding: "2.5px 15px",
    border: "1px solid #EDDFFF",
    marginLeft: 15,
    borderRadius: 4,
  },
  cardVoucher: {
    display: "flex",
    padding: "10px",
  },
  wrapThumb: {
    width: 70,
    display: "flex",
    alignItems: "center",
    "@media(max-width: 280px)": {
      width: 35,
    },
    "@media (max-width: 360px)": {
      width: 35,
    },
    "@media(min-width: 960px)": {
      width: 70,
    },
  },
  thumb: {
    objectFit: "cover",
    width: "100%",
  },
  liquidVocherPrimary: {
    fontSize: "14px",
  },
  liquidVocherSecondary: {
    fontSize: "12px",
    color: "#88929F",
  },
  boxButton: {
    display: "flex",
    flexDirection: "row",
    height: 50,
    maxWidth: "100%",
    width: 960,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    margin: "0 auto",
    paddingLeft: 30,
    // paddingRight: 30,
    zIndex: 999,
    // backgroundColor: "#5675D3",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  },
  buttonSelect: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    width: "40%",
    marginLeft: -30,
    cursor: "pointer",
  },
  buttonSelect1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
    backgroundColor: "#5675D3",
    cursor: "pointer",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  },
  btnVoucher: {
    display: "flex",
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #7072AF",
    backgroundColor: "#EDF1FF",
    fontSize: 12,
    width: "100%",
    outline: "none",
    color: "rgba(0,0,0,0.6)",
    alignItems: "center",
    textTransform: "capitalize",
    justifyContent: "left",
    "&:hover": {
      backgroundColor: "#EDF1FF",
    },
  },
}));

export default useStyles;
